const socialMedia = {
  facebook: 0,
  twitter: 1,
  instagram: 2,
  linkedIn: 3,
  youtube: 4,
}
export default socialMedia
